import { Card, Flex, Tabs, Typography } from 'antd'
import CSS from 'csstype'
import styled from 'styled-components'

export const headerStyle: CSS.Properties = {
  paddingLeft: '1em',
  paddingRight: '1em',
}

export const whiteContentStyle: CSS.Properties = {
  backgroundColor: '#fff',
}

export const pagePaddingStyle: CSS.Properties = {
  padding: '24px clamp(16px, 3vw, 32px) 32px',
  boxSizing: 'border-box',
}

export const formMaxWidthStyle: CSS.Properties = {
  maxWidth: '1200px',
}

export const sectionBlockStyle: CSS.Properties = {
  marginBottom: '16px',
}

export const sectionTitleStyle: CSS.Properties = {
  display: 'block',
  fontSize: '12px',
  marginBottom: '8px',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
}

export const fieldCellStyle: CSS.Properties = {
  flex: '1 1 160px',
  minWidth: '160px',
  maxWidth: '280px',
}

export const sourceDestinationCardsRowStyle: CSS.Properties = {
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
}

export const sourceDestinationCardStyle: CSS.Properties = {
  flex: '1 1 320px',
  minWidth: '280px',
}

export const seedOrderEditorLayoutStyle: CSS.Properties = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 2fr) minmax(320px, 1fr)',
  gap: '24px',
  alignItems: 'start',
}

export const seedOrderEditorFormColumnStyle: CSS.Properties = {
  width: '100%',
  minWidth: 0,
}

export const seedOrderEditorSidebarColumnStyle: CSS.Properties = {
  width: '100%',
  alignSelf: 'flex-start',
  position: 'sticky',
  top: '24px',
}

export const inventoryInfoMainCardStyle: CSS.Properties = {
  border: '1px solid #5B8FF9',
  backgroundColor: '#EDF5FF',
  borderRadius: '10px',
}

export const inventoryInfoNestedCardStyle: CSS.Properties = {
  border: '1px solid #D6E4FF',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',
}

export const inventoryInfoSectionTitleStyle: CSS.Properties = {
  marginTop: 0,
  marginBottom: '12px',
}

export const inventoryInfoHintRowStyle: CSS.Properties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '12px',
}

export const inventoryInfoHintIconStyle: CSS.Properties = {
  color: '#2F54EB',
  fontSize: '14px',
}

export const inventoryInfoHintTextStyle: CSS.Properties = {
  color: '#2F54EB',
  fontSize: '13px',
}

export const inventoryInfoNestedCardWrapStyle: CSS.Properties = {
  position: 'relative',
}

export const inventoryInfoWarningIconStyle: CSS.Properties = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  color: '#FAAD14',
  fontSize: '14px',
  zIndex: 1,
  pointerEvents: 'none',
}

export const inventoryInfoRowStyle: CSS.Properties = {
  width: '100%',
}

export const inventoryInfoRowStackedStyle: CSS.Properties = {
  width: '100%',
}

export const inventoryInfoRowLabelStyle: CSS.Properties = {
  color: '#4F5B7A',
  fontSize: '13px',
}

export const inventoryInfoRowValueStyle: CSS.Properties = {
  color: '#1F2A44',
  fontWeight: 600,
  fontSize: '13px',
  textAlign: 'right',
}

export const inventoryInfoRowValueStackedStyle: CSS.Properties = {
  color: '#1F2A44',
  fontWeight: 600,
  fontSize: '13px',
  marginTop: '4px',
}

export const inventoryInfoCalcDividerStyle: CSS.Properties = {
  margin: '4px 0',
  borderTop: '1px solid #C5D9FF',
}

export const cardFieldStyle: CSS.Properties = {
  marginBottom: '12px',
}

export const InputUnitSuffix = styled(Typography.Text)`
  font-size: inherit;
  user-select: none;
  white-space: nowrap;
`

export const TabContentWrapper = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const FilterActionBar = styled(Flex)`
  padding-left: 1.5em;
  padding-right: 1.5em;
  padding-top: 1em;
  padding-bottom: 1em;
`

export const SearchStyle: CSS.Properties = {
  maxWidth: '400px',
}

export const TableScrollWrapper = styled.div`
  width: 100%;
  overflow: auto;
  flex: 1;
  min-height: 0;
`

export const ListHeaderBar = styled(Flex)`
  padding-left: 1em;
  padding-right: 1em;
`

export const PageHeader = styled(Flex)`
  padding-bottom: 1em;
  padding-left: 1em;
  padding-right: 1em;
`

export const PageTitle = styled(Typography.Title)`
  && {
    font-weight: bold;
    margin-block: 0;
  }
`

export const PageBody = styled.div`
  padding: 1.5em;
  background: #fafafa;
  flex: 1;
  width: 100%;
  box-sizing: border-box;
`

export const seedOrderTabsBarStyles: CSS.Properties = {
  paddingLeft: '1.5em',
  paddingRight: '1.5em',
  backgroundColor: '#FFFFFF',
}

export const seedOrderTabsStyles: CSS.Properties = {
  flexGrow: 1,
  backgroundColor: '#FAFAFA',
  minHeight: 0,
}

export const seedOrderTabContainerStyles: CSS.Properties = {
  display: 'flex',
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
}

export const SeedOrderDetailsTabs = styled(Tabs)`
  display: flex;
  flex: 1;
  min-height: 0;

  .ant-tabs-content-holder {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .ant-tabs-content {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .ant-tabs-tabpane {
    height: 100%;
    overflow: auto;
  }
`

export const FullWidthFlex = styled(Flex)`
  width: 100%;
`

export const LeftColumn = styled(Flex)`
  flex: 1;
  min-width: 0;
`

export const RightColumn = styled(Flex)`
  flex: 2;
  min-width: 0;
`

export const FullWidthCard = styled(Card)`
  width: 100%;
`

export const TopPadding = styled.div`
  padding-top: 12px;
`

export const seedOrderNotesRootStyle: CSS.Properties = { width: '100%' }
export const seedOrderNotesLoadingStyle: CSS.Properties = { padding: '16px 0' }
export const seedOrderNotesEmptyStyle: CSS.Properties = { color: '#8C8C8C', fontSize: '13px', padding: '8px 0' }
export const seedOrderNotesTimelineStyle: CSS.Properties = { position: 'relative', paddingLeft: '28px' }
export const seedOrderNotesRailStyle: CSS.Properties = {
  position: 'absolute',
  left: '9px',
  top: 0,
  bottom: 0,
  width: '2px',
  backgroundColor: '#D9D9D9',
}
export const seedOrderNotesItemStyle: CSS.Properties = { position: 'relative', paddingRight: '32px' }
export const seedOrderNotesEditActionsStyle: CSS.Properties = { marginTop: '8px' }
export const seedOrderNotesMarkerStyle: CSS.Properties = {
  position: 'absolute',
  left: '-24px',
  top: '6px',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: '#52C41A',
  border: '2px solid #FFFFFF',
  boxSizing: 'content-box',
}
export const seedOrderNotesMoreActionsWrapStyle: CSS.Properties = { position: 'absolute', right: 0, top: '-4px' }
export const seedOrderNotesTextStyle: CSS.Properties = {
  color: '#262626',
  fontSize: '14px',
  lineHeight: '22px',
  whiteSpace: 'pre-wrap',
}
export const seedOrderNotesMetaStyle: CSS.Properties = {
  color: '#8C8C8C',
  fontSize: '12px',
  lineHeight: '20px',
  marginTop: '4px',
}

const TagPill = styled.div<{ backgroundColor: string }>`
  display: flex;
  height: 22px;
  padding: 0 12px;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  background: ${(props) => props.backgroundColor};
  color: white;
  font-size: 12px;
  width: fit-content;
`

export const PedigreeLabel = TagPill
export const StatusLabel = TagPill

export const rowCursorPointerStyle: CSS.Properties = {
  cursor: 'pointer',
}
